import React, {Fragment, Component} from "react";
import { connect } from "react-redux";
import LoadingDots from '../components/ui/LoadingDots';

import MasterTable from './mentorTable/MasterTable';
import MentorTable from './mentorTable/MentorTable';
import SlaveTable from './mentorTable/SlaveTable';

import { getFlows } from '../actions';
import { setMentor, setAllowDefence } from '../actions/mentor';
import { Tabs } from '../const/mentors';
import ArchieveTable from "./mentorTable/ArchieveTable";

class Mentor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      navOpen: true,
    }
  }

  componentDidMount() {
    const { user } = this.props;
    if (user.is_master_mentor) this.setState({'activeTab': 1});
    else if (user.is_mentor) this.setState({'activeTab': 4});
    this.props.getFlows(true);
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const { user } = this.props;
    if (user.is_master_mentor && !prevProps.user.is_master_mentor) this.setState({'activeTab': 1});
    else if (user.is_mentor && !prevProps.user.is_mentor) this.setState({'activeTab': 4});
  }

  countRequestByTab = tab => {
    const { process: { all } } = this.props;
    const requests = all.filter(item => typeof item !== 'undefined');

    if (!tab || !tab.count || !tab.filter) return '';

    const count = tab.filter(requests).length;

    return count || 0;
  };

  renderTab = () => {
    const { activeTab } = this.state;
    const { process: { all }, mentors: { slave }, setMentor, user, setAllowDefence } = this.props;

    const activeTabContent = Tabs.find(tab => tab.id === activeTab);
    const filter = Tabs.find(tab => tab.id === activeTab).filter;

    const toShow = typeof filter !== 'undefined' ? filter(all) : all.filter(item => typeof item !== 'undefined');

    //TODO: Rebuild
    switch (activeTab) {
      case 0: {
        return (
            <MasterTable
                title={activeTabContent.title}
                rows={toShow}
                slave={slave}
                setMentor={setMentor}
            />
        );
      }
      case 1: {
        return (
            <MasterTable
                title={activeTabContent.title}
                rows={toShow}
                slave={slave}
                setMentor={setMentor}
            />
        );
      }
      case 2: {
        return (
            <MasterTable
                title={activeTabContent.title}
                rows={toShow}
                slave={slave}
                setMentor={setMentor}
            />
        );
      }
      case 6:{
        return (
          <ArchieveTable
              title={activeTabContent.title}
              rows={toShow}
              slave={slave}
              setMentor={setMentor}
              isMasterMentor={user.is_master_mentor}
          />
        );
      }
      case 3: {
        return (
          <MentorTable title={activeTabContent.title} rows={slave} all={all}/>
        )
      }
      case 4: {
        return (
            <SlaveTable title={activeTabContent.title} rows={toShow} setAllowDefence={setAllowDefence} />
        )
      }
      case 5: {
        return (
          <SlaveTable title={activeTabContent.title} rows={toShow} setAllowDefence={setAllowDefence} />
        )
      }
      default: {
        return (
          <div className="reportbox-content">
            <h4>{activeTabContent.title}</h4>
            <div className="line" />
          </div>
        );
      }
    }
  };

  toggleTab = (tab) => () => {
    this.setState({
      activeTab: tab.id,
    });
  }

  render() {
    const { user, loaders } = this.props;
    const { activeTab , navOpen } = this.state;
    const role =  user.is_master_mentor ? 'master' : (user.is_mentor ? 'mentor' : null);

    const activeTabContent = Tabs.find(tab => tab.id === activeTab);

    return (
      <div id="content" className="nopad">
        <LoadingDots show={['flows', 'mm-process','slave-mentors','mentor-process'].some(el => loaders[el])}>
          <div className="reportbox">
            <div className="reportbox-content-row">
              <div className="reportbox-sidebar">
                <div className="reportbox-sidebar-heading">
                  <span className="reportbox-sidebar-heading-title">Заявки от пользователей</span>
                </div>
                <div className="reportbox-sidebar-menu">
                  <ul className={`nav nav-pills nav-stacked ${navOpen ? 'nav--opened' : ''}`}>
                    {Tabs.filter(tab => tab.roles.indexOf(role) > -1).map(tab => (
                      <Fragment key={tab.id}>
                        {
                          tab.id === 6 && (user?.is_master_mentor || user?.is_mentor) ? <li>
                            <a href={`/planner/`} className="btn btn-primary btn-for-planner">
                              Перейти в планировщик
                            </a>
                          </li> : null
                        }
                        <li className={this.state.activeTab === tab.id ? 'active' : ''}>
                          <a onClick={this.toggleTab(tab)}>
                            <span className="nav-pills-label">{tab.title}</span>
                            {!!tab.count &&
                                <span className={`label label-${tab.count} label--circle`}>
                                  {this.countRequestByTab(tab)}
                                </span>
                            }
                          </a>
                        </li>
                      </Fragment>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="reportbox-content-viewport">
                {!!role
                    && activeTabContent
                    && activeTabContent.roles.indexOf(role) > -1
                    && this.renderTab(this.state.activeTab)}
              </div>
            </div>
          </div>
        </LoadingDots>
      </div>
    )
  }
}

function mapStateToProps(state) {
  //create hash table for flows
  const hashFlows = {};
  for( let item of state.forms.flows){
    hashFlows[item.id] = item;
  }

  const getProcess = () => {
    return state.forms.process.all.length ? {
      all: state.forms.process.all.map((item) => {
        return {
          ...item,
          flow: item?.flow_id && hashFlows[item.flow_id],
          flow_archived: item?.flow_id
            && hashFlows[item.flow_id]?.protection_date_end
            && Math.round(
                new Date(hashFlows[item.flow_id]?.protection_date_end).getTime() / 1000) < Math.floor(Date.now() / 1000
              )
        }
      })
    } : state.forms.process
  }

  return {
    loaders: state.forms.loaders,
    process: getProcess(),
    mentors: state.forms.mentors,
    user: state.forms.user,
  };
}

const mapDispatchToProps = {
  getFlows,
  setMentor,
  setAllowDefence,
};

export default connect(mapStateToProps, mapDispatchToProps)(Mentor);
